/**
 * The show as the person calls it: its title, else its acts, else nothing (SCRUM-909). The ONE rule for every place that names
 * a show — «My shows», the inbox and the calendar (`apps/web/src/shows/inbox.ts#showSubject`) and the warehouse's «who holds
 * this» (`apps/api/src/stock/stock-reservations.service.ts`). A show made the ordinary way has no title, only acts, so a place
 * that read the title alone said nothing («Offer 01 · Nov 14 ×4») where «My shows» said «The Band».
 *
 * `performances` are the acts' NAMES in running order (the caller sorts); a blank title is no title.
 */
export function showSubject(show) {
    return show.title?.trim() || show.performances.join(", ") || undefined;
}
//# sourceMappingURL=show-subject.js.map